import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
    selector: 'app-beneficios-reforma-pensiones',
    templateUrl: './beneficios-reforma-pensiones.component.html',
    styleUrl: './beneficios-reforma-pensiones.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(24px)' }),
                animate('300ms cubic-bezier(0.23, 1, 0.32, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
              style({ position: 'absolute', width: '100%', opacity: 1 }),
              animate('200ms', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class BeneficiosReformaPensionesComponent implements AfterViewInit {

  @ViewChild('benefitsTrack') benefitsTrack?: ElementRef<HTMLDivElement>;

  selectedBenefit: string = "aumento-pgu";
  canScrollLeft: boolean = false;
  canScrollRight: boolean = false;

  benefits = [
    { key: 'aumento-pgu', text: 'Aumento PGU' },
    { key: 'compensacion-mujeres', text: 'Compensación a mujeres' },
    { key: 'ampliacion-seguro-de-lagunas', text: 'Ampliación del Seguro de Lagunas' },
    { key: 'beneficios-cotizados', text: 'Beneficios por años cotizados' },
    { key: 'ajuste-de-pension', text: 'Ajuste de pensión a 2 UF' }
  ];

  selectBenefit(key: string) {
    this.selectedBenefit = key;
  }

  ngAfterViewInit(): void {
    this.updateScrollState();
    requestAnimationFrame(() => this.updateScrollState());
  }

  updateScrollState(): void {
    const track = this.benefitsTrack?.nativeElement;
    if (!track) return;

    this.canScrollLeft = track.scrollLeft > 1;
    this.canScrollRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
  }

  scrollBenefits(direction: 'left' | 'right'): void {
    const track = this.benefitsTrack?.nativeElement;
    if (!track) return;

    track.scrollBy({
      left: direction === 'left' ? -track.clientWidth : track.clientWidth,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateScrollState();
  }
}